// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.box-shadow {
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 10px 0 rgba(0, 0, 0, 0.19);
}
.iconbutton {
    width: 24px;
    height: 24px;
    padding: 0;
    margin: 0;
    line-height: 24px;
    align-self:center;
}
.iconbutton-icon{
    vertical-align:baseline;
}
.headline {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
.selected {
    color: var(--appbuilder-primary-color);
    border: 1px solid var(--appbuilder-primary-color);
    border-radius: 50%;
    /*color: var(--appbuilder-hover-color);*/
}`, "",{"version":3,"sources":["webpack://./src/app/appbuilder/controls/layoutunitthickness/layoutunitthickness.component.css"],"names":[],"mappings":"AAAA;IACI,4EAA4E;AAChF;AACA;IACI,WAAW;IACX,YAAY;IACZ,UAAU;IACV,SAAS;IACT,iBAAiB;IACjB,iBAAiB;AACrB;AACA;IACI,uBAAuB;AAC3B;AACA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,sCAAsC;IACtC,iDAAiD;IACjD,kBAAkB;IAClB,wCAAwC;AAC5C","sourcesContent":[".box-shadow {\n    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 10px 0 rgba(0, 0, 0, 0.19);\n}\n.iconbutton {\n    width: 24px;\n    height: 24px;\n    padding: 0;\n    margin: 0;\n    line-height: 24px;\n    align-self:center;\n}\n.iconbutton-icon{\n    vertical-align:baseline;\n}\n.headline {\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n}\n.selected {\n    color: var(--appbuilder-primary-color);\n    border: 1px solid var(--appbuilder-primary-color);\n    border-radius: 50%;\n    /*color: var(--appbuilder-hover-color);*/\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
